module.exports = __webpack_public_path__ + "media/images/textSelectionSample__dropdown@2x-c454677c4901e64d5037a4ebd9e4c310.png";